<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Bq8TbP/tc-custom/9781960436634.jpg?1731411132662" alt="This image is the cover for the book La profecía del dragón"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">La profecía del dragón
      </h1>
      <p class="bookDescription body article font2">
        <p>¿Es posible que lo que estamos presenciando en el final de los tiempos sea la respuesta a una revelación antigua, y que ahora estemos viendo su despliegue? ¿Hay más en este mundo de lo que ven nuestros ojos? ¿Existe una visión antigua que revela lo que está ocurriendo ahora en nuestro mundo? ¿Hay una profecía antigua que nos dice lo que el futuro nos depara? ¿Existe una fuerza antigua que operó en tiempos antiguos y que ahora está actuando en el mundo moderno, determinando el curso de los eventos actuales, desde Israel hasta lo que amenaza con una Tercera Guerra Mundial, y tocando cada una de nuestras vidas? ¿Cuál es el misterio del dragón? ¿Estamos en medio de una guerra que ni siquiera nos damos cuenta que se está librando contra nosotros? ¿Cuál es el cronómetro más preciso que señala los últimos días? ¿Podemos descubrir sus planes y estrategias, incluso aquellos dirigidos contra nuestras propias vidas? ¿Hubo una revelación de hace tres mil años que determinó el ataque de Hamas a Israel, hasta el año, el mes, la semana y el día exacto? ¿Qué es el Fin de los Días, y están aquí? ¿Qué nos depara el futuro? Y mucho, mucho más Después de ocho bestsellers en el New York Times, Jonathan Cahn lanza ahora su nuevo éxito de ventas, LA PROFECÍA DEL DRAGÓN: Israel, la resurrección oscura y el fin de los tiempos, la revelación asombrosa que abre el misterio de nuestros tiempos, los eventos que sacuden nuestro mundo y lo que nos espera en los días venideros. El último libro de Jonathan Cahn abrirá los misterios de lo que ha sido, lo que está ocurriendo ahora y lo que está por suceder, incluso el fin de la era, desbloqueando revelaciones impactantes que te permitirán ver lo que está sucediendo en tu mundo de una manera completamente nueva.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jonathan Cahn
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0246dbc5